import { Redirect } from "react-router-dom";

export const HomePage = () => <Redirect to="/error" />;
